<template>
    <v-container  v-if="item && company" >
    <h2 class="text-h4">{{$t('overview.title')}}</h2>
    <field-form hide-default-button @save="save">
    <v-row>
        <v-col cols="12" lg="6">
            <v-card
            id="pfid1618852873">
                <v-card-title>{{$t('overview.tasks.title')}}</v-card-title>
                <v-list>
                    <v-list-item id="pfid1618852908" link @click="startWizard()" v-if="!status.active">
                        <v-list-item-icon>
                            <v-icon color="success">$settings</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('overview.tasks.wizard')}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!--
                    <v-list-item id="pfid1618852913" link v-else>
                        <v-list-item-icon>
                            <v-icon color="success">$campaign</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>New campaign</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    -->
                    <v-list-item id="pfid1618852918" :to="{name: 'contact-import'}">
                        <v-list-item-icon>
                            <v-icon>$importCustomers</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('overview.tasks.customers')}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item id="pfid1619469269"  :to="{name: 'order-import'}">
                        <v-list-item-icon>
                            <v-icon>$importOrders</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('overview.tasks.orders')}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item id="pfid1618852922" link v-if="isCancelled || status.active || isMFP" @click="mfp= false; confirmDeactivation = true">
                        <v-list-item-icon>
                            <v-icon v-if="isCancelled || isMFP" color="success">$active</v-icon>
                            <v-icon v-else color="warning">$inactive</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-if="isCancelled || isMFP">{{$t('overview.tasks.activate.title')}}</v-list-item-title>
                            <v-list-item-title v-else-if="status.active">{{$t('overview.tasks.deactivate.title')}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item id="pfid1660903065"  link v-if="!isActive" @click="mfp= true; confirmDeactivation = true;">
                        <v-list-item-icon>
                            <v-icon color="warning">$purged</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$t('overview.tasks.markForPurge.title')}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <confirm-dialog :button-caption="confirmButtonCaption" v-model="confirmDeactivation" :saving="saving.active" @confirm="deactivate()">
                    <div v-if="mfp" v-html="$t('overview.tasks.markForPurge.dialog')"></div>
                    <div v-else-if="isCancelled || isMFP" v-html="$t('overview.tasks.activate.dialog')"></div>
                    <div v-else v-html="$t('overview.tasks.deactivate.dialog')"></div>
                </confirm-dialog>
            </v-card>
            <v-card id="pfid1618852934" class="mt-5">
                <v-card-title>{{$t('overview.setup.title')}}</v-card-title>
                <v-list>
                    <v-list-item
                    id="pfid1618852951"
                    two-line 
                    >
                        <v-list-item-icon>
                            <v-icon>$name</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <template v-if="!edit.name">
                            <v-list-item-subtitle>{{$t('common.name')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            </template>
                            <v-text-field v-else dense :label="$t('common.name')" v-model="fields.name" :rules="[v => !!v || $t('form.rules.required')]"/>
                        </v-list-item-content>
                        <v-list-item-action>
                            <action-button v-if="!edit.name" @click="editable('name')"/>
                            <v-row v-else class="my-0 mr-0">
                                <action-button icon="$close" @click="edit.name=false" :tooltip="$t('dialog.back')"/>
                                <action-button icon="$save" :tooltip="$t('form.save')" @click="savin.name = true" type="submit" :loading="savin.name"/>
                            </v-row>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item
                    id="pfid1618852965"
                    two-line 
                    >
                        <v-list-item-icon>
                            <v-icon>$currency</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <template v-if="!edit.currency">
                            <v-list-item-subtitle>{{$t('domains.currency')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatCurrency(item.currency)  }}</v-list-item-title>
                            </template>
                            <v-select v-else dense v-model="fields.currency" :items="currenciesList" :label="$t('domains.currency')" />
                        </v-list-item-content>
                         <v-list-item-action>
                            <action-button v-if="!edit.currency" @click="editable('currency')"/>
                            <v-row v-else class="my-0 mr-0">
                                <action-button icon="$close" @click="edit.currency=false" :tooltip="$t('dialog.back')"/>
                                <action-button icon="$save" :tooltip="$t('form.save')"  @click="savin.currency = true" type="submit" :loading="savin.currency"/>
                            </v-row>
                            
                        </v-list-item-action>
                    </v-list-item>

                    <v-list-item
                    id="pfid1620219477"
                    two-line 
                    >
                        <v-list-item-icon>
                            <v-icon>$box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <template>
                            <v-list-item-subtitle>{{$t('webboxes.title')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatWebboxState(item.boxesAllowed, canAllowWebbox)  }}</v-list-item-title>
                            </template>
                        </v-list-item-content>
                         <v-list-item-action>
                            <action-button v-if="canAllowWebbox" :to="{name: 'webboxes'}"/>
                            <v-btn v-else icon disabled><v-icon>$edit</v-icon></v-btn>
                        </v-list-item-action>
                    </v-list-item>

                    <v-list-item
                    id="pfid1643911720"
                    two-line 
                    >
                        <v-list-item-icon>
                            <v-icon>$cookie</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <template v-if="!edit.cookieCheck">
                            <v-list-item-subtitle>{{$t('overview.setup.cookieCheck')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ item.cookieCheck ? $t('common.boolean.true') : $t('common.boolean.false') }}</v-list-item-title>
                            </template>
                            <v-switch class="ml-1 mt-0" dense v-else v-model="fields.cookieCheck" :label="$t('overview.setup.cookieCheck')"/>
                        </v-list-item-content>
                         <v-list-item-action>
                            <action-button v-if="!edit.cookieCheck" @click="editable('cookieCheck')"/>
                            <v-row v-else class="my-0 mr-0">
                                <action-button icon="$close" @click="edit.cookieCheck=false" :tooltip="$t('dialog.back')"/>
                                <action-button icon="$save" :tooltip="$t('form.save')" @click="savin.cookieCheck = true" type="submit" :loading="savin.cookieCheck"/>
                            </v-row>
                        </v-list-item-action>
                    </v-list-item>
                    
                    <v-list-item
                    id="pfid1618852971"
                    two-line
                    >
                        <v-list-item-icon>
                            <v-icon>$timezone</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <template v-if="!edit.timezone">
                            <v-list-item-subtitle>{{$t('overview.setup.timezone')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatTimezone(item.timezone) }}</v-list-item-title>
                            </template>
                            <v-autocomplete dense v-else id="pfid1631102396" :items="timezones" :rules="[v => !!v || $t('form.rules.required')]" v-model="fields.timezone" :label="$t('overview.setup.timezone')" />
                            
                        </v-list-item-content>
                         <v-list-item-action>
                            <action-button v-if="!edit.timezone" @click="editable('timezone')"/>
                            <v-row v-else class="my-0 mr-0">
                                <action-button icon="$close" @click="edit.timezone=false" :tooltip="$t('dialog.back')"/>
                                <action-button icon="$save" :tooltip="$t('form.save')" @click="savin.timezone = true" type="submit" :loading="savin.timezone"/>
                            </v-row>
                        </v-list-item-action>
                    </v-list-item>
                    
                    <v-list-item
                    id="pfid1618852978"
                    two-line
                    >
                        <v-list-item-icon>
                            <v-icon>$sale</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <template v-if="!edit.defaultSale">
                            <v-list-item-subtitle>{{$t('overview.setup.sale')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ item.defaultSale }}%</v-list-item-title>
                            </template>
                            
                            <v-slider v-else
                            v-model="fields.defaultSale"
                            dense
                            :style="{ 'position':'relative', 'top': '0.5em' }"
                            height="15px"
                            :min="0"
                            :max="100"
                            :step="1">
                            
                            
                            <template v-slot:append>
                                <span :style="{ 'width': '100px', 'position':'relative', 'top': '-0.25em'}">{{ fields.defaultSale }}%</span>
                                
                            </template>
                            
                            </v-slider>
                            
                        </v-list-item-content>
                         <v-list-item-action>
                            <action-button v-if="!edit.defaultSale" @click="editable('defaultSale')"/>
                            <v-row v-else class="my-0 mr-0">
                                <action-button icon="$close" @click="edit.defaultSale=false" tooltip="Back"/>
                                <action-button icon="$save" tooltip="Save" @click="savin.defaultSale = true" type="submit" :loading="savin.defaultSale"/>
                            </v-row>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item
                    id="pfid1618852985"
                    two-line
                    >
                        <v-list-item-icon>
                            <v-icon>$platform</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('domains.platform')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ platform }}</v-list-item-title>
                        </v-list-item-content>
                         <v-list-item-action>
                            <action-button :to="`tracking/${item.platform ? item.platform.toLowerCase() : ''}`"/>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-col>
        <v-col cols="12" lg="6">
            <v-card
            id="pfid1618852997">
                <v-card-title>{{$t('overview.status.title')}}</v-card-title>
                <v-list>
                    <v-list-item
                    id="pfid1618853031" 
                    >
                        <v-list-item-icon>
                            <v-icon :color="status.color">{{ status.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('domains.status.title')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ status.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    id="pfid1618853038" 
                    >
                        <v-list-item-icon>
                            <v-icon>$visitors</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('domains.monthlyVisitors',  {date: subFrom })}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatNumber(item.stats.monthlyUsers) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    id="pfid1618853043"
                    :to="{name: 'feeds'}" 
                    >
                        <v-list-item-icon>
                            <v-icon>$productFeed</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('domains.productCount')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatNumber(item.stats.products) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    id="pfid1654354032"
                    :to="{name: 'contacts'}"  
                    >
                        <v-list-item-icon>
                            <v-icon>$emailRecipients</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('domains.emailCount')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatNumber(item.totalEmailRecipients) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    id="pfid1659048125"
                    :to="{name: 'domain-dashboard'}"
                    exact  
                    >
                        <v-list-item-icon><v-icon>$sales</v-icon></v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('domains.sales', {date: subFrom })}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatCurrencyAmount(item.stats.dreamroiSales, item.currency, 0) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-icon><v-icon>$sentTotal</v-icon></v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('domains.emailsSent', { date: subFrom })}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatNumber(item.stats.emailsSent,0) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    id="pfid1618853049" 
                    >
                        <v-list-item-icon>
                            <v-icon>$recommendationsUpdate</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('overview.status.recommendations')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatDate(item.recommendationsUpdated) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    id="pfid1618853057" >
                        <v-list-item-icon>
                            <v-icon>$productsUpdate</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('overview.status.products')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatDate(item.productsUpdated) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
            <v-card id="pfid1618853013" class="mt-5">
                <v-card-title>{{$t('overview.capabilities.title')}}<v-spacer /><action-button :loading="loading" icon="$refresh" tooltip="Refresh" @click="refresh"/>
                </v-card-title>

                <v-banner elevation="0" :mobile-breakpoint="capabilitiesBannerBreakpoint" color="warning" icon="$warn" v-if="isIncomplete">
                    {{ $t('overview.capabilities.incomplete') }}
                    <template #actions>
                            <v-btn
                            text
                            @click="startWizard()"
                        >
                        {{ $t('overview.tasks.wizard')}}
                    </v-btn>
                    </template>
                </v-banner>
                <v-banner dark elevation="0" :mobile-breakpoint="capabilitiesBannerBreakpoint" color="error" icon="$nok" v-else-if="productFeedError">
                    {{ $t('overview.capabilities.productFeedError') }}
                    <template #actions>
                            <v-btn
                            text
                            :to="{name: 'feeds'}"
                        >
                        {{ $t('overview.goToFeeds')}}
                    </v-btn>
                    </template>
                </v-banner>
                <v-banner dark elevation="0" :mobile-breakpoint="capabilitiesBannerBreakpoint" color="info" icon="$ok_outline" v-else-if="!hasProducts">
                    {{ $t('overview.capabilities.noProducts') }}
                </v-banner>
                <v-banner dark elevation="0" :mobile-breakpoint="capabilitiesBannerBreakpoint" color="info" icon="$ok_outline" v-else-if="!hasRecommendations">
                    {{ $t('overview.capabilities.noRecommendations') }}
                </v-banner>
                <v-banner elevation="0" :mobile-breakpoint="capabilitiesBannerBreakpoint" color="success" icon="$ok" v-else-if="canAllowWebbox && (!item.boxesAllowed || !hasCampaigns)">
                    {{ $t('overview.capabilities.initComplete') }}
                    <template #actions>
                            <!-- <div class="d-flex flex-column justify-end"> -->
                            <v-btn
                            text
                            :to="{name: 'webboxes'}"
                            >
                                {{ $t('overview.goToWebboxes')}}
                            </v-btn>
                            <v-btn
                            text
                            :to="{name: 'campaigns-automatic'}"
                            >
                                {{ $t('overview.goToCampaigns')}}
                            </v-btn>
                            <!-- </div> -->
                    </template>
                </v-banner>
                <v-banner dark elevation="0" :mobile-breakpoint="capabilitiesBannerBreakpoint" color="info" icon="$info" v-if="!hasDNSSetupCompleted(item.capabilities)">
                    {{ $t('overview.capabilities.dnsIncomplete')}}
                    <template #actions>
                            <v-btn
                            text
                            :to="{name: 'mailing'}"
                        >
                        {{ $t('overview.goToMailing')}}
                    </v-btn>
                    </template>
                </v-banner>
                <v-list>
                    <v-list-item v-for="(v,c) in item.capabilities" :key="c">
                        <v-list-item-icon>
                            <tooltip-icon 
                            :icon="(v ? '$ok' : '$nok') + (requiredCapabilities[c] ? '' : '_outline')"
                            :tooltip="(requiredCapabilities[c] ? $t('form.required') : $t('form.optional'))+', ' + (v ? $t('overview.capabilities.working') : $t('overview.capabilities.notWorking'))"
                            :color="v ? 'success' : 'error'" />
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ formatCapability(c) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-col>
    </v-row>
    </field-form>
    <v-dialog persistent v-model="nestedRoute" max-width="1000px">
    <router-view />
    </v-dialog>
    </v-container>
    <v-container v-else>
    <v-row>
    <v-col cols="12" md="6" v-for="i in [0,1,2,3]" :key="i">
    <v-skeleton-loader type="card">
    </v-skeleton-loader>
    </v-col>
    </v-row>
    </v-container>
</template>
<script>

import { mapState, mapGetters } from "vuex";
import Capabilities from "@/mixins/capabilities"
import DomainStatus from "@/mixins/domain-status"
import Formatters from "@/mixins/formatters"
import EntityForm from "@/mixins/entity-form"
import DnsRecords from "@/mixins/dns-records"
import Wizards from "@/mixins/wizards";
import Timezones from "@/mixins/timezones";

export default {
    name: 'DomainOverview',
    mixins: [Capabilities, DomainStatus, Formatters, EntityForm, Wizards, DnsRecords, Timezones],
    data() {
      return {
          loading: false,
          endpoint: 'domains',
          edit: {
              name: false,
              currency: false,
              timezone: false,
              defaultSale: false,
              cookieCheck: false,
          },
          // saving colides with the entity-form mixin (looking forward to the composition API...)
          savin: {
              name: false,
              currency: false,
              timezone: false,
              cookieCheck: false,
              active: false,
              defaultSale: false
          },
          fields: {
              name: null,
              currency: null,
              timezone: null,
              cookieCheck: null,
              active: null,
              defaultSale: null
          },
          confirmDeactivation: false,
          mfp: false,
          capabilitiesBannerBreakpoint: this.$vuetify.breakpoint.thresholds.lg
      };
    },
    computed: {
        isCancelled() {
            if(!this.item) {
                return false;
            }
            return this.item.active == 'CANCELLED';
        },
        isMFP() {
            if(!this.item) {
                return false;
            }
            return this.item.active == 'MARKED_FOR_PURGE';
        },
        platform() {
            return this.formatPlatform(this.item?.platform);
        },
        nestedRoute: {
            get() {
                return this.$route.name != 'domain-overview';
            },
            set(v) {
                if(!v) {
                    this.$router.push({name: 'domain-overview'});
                }
            }
        },
        subFrom() {
            return this.formatDate(this.company.activeSubscription?.from)
        },
        confirmButtonCaption() {
            if(this.mfp) {
                return 'overview.tasks.markForPurge.title';
            }
            if(this.isCancelled || this.isMFP) {
                return 'overview.tasks.activate.title';
            }
            
            return 'overview.tasks.deactivate.title';
        },
        ...mapState('domains', ['item']),
        ...mapGetters('domains', ['canAllowWebbox', 'isActive', 'isIncomplete', 'hasProducts', 'hasRecommendations', 'productFeedError', 'hasCampaigns', 'currenciesList']),
        ...mapState('companies', {company: 'item'})
    },
    methods: {
        startWizard() {
            this.$store.commit('ui/wizard', {value: true });
            this.$router.push('feeds');
        },
        async refresh() {
            if(!this.hasDNSSetupCompleted(this.item.capabilities)) {
                await this.getDNSRecords();
            } else {
                console.debug('DNS records not retrieved - DNS setup complete');
            }
            this.loading = true;

            await this.$store.dispatch('domains/get', { id: this.item.id });
            this.loading = false;
        },
        editable(key) {
            Object.keys(this.edit).forEach(k => this.edit[k] = false);
            this.edit[key] = true;
            this.savin[key] = false;
        },
        afterSave() {
            var activeField = Object.keys(this.savin).find(k => this.savin[k] == true);
            this.savin[activeField] = false;
            this.edit[activeField] = false;
            if(activeField == 'active') {
                // hide the dialog
                this.confirmDeactivation = false;
                this.mfp = false;
            }
            // reload the domains list so the company dashboard is up to date
            this.$store.dispatch('domains/list', { companyId: this.item.companyID });
        },
        deactivate() {
            if(this.mfp) {
                this.fields.active = 'MARKED_FOR_PURGE';
            } else if(this.isCancelled || this.isMFP) {
                this.fields.active = 'INCOMPLETE';
            } else {
                this.fields.active = 'CANCELLED';
            }
        
            this.savin.active = true;
            this.save();
        },
        formatWebboxState(allowed, canAllow) {
            if(allowed) {
                return this.$t('overview.webboxes.enabled');
            } else if(canAllow) {
                return this.$t('overview.webboxes.canAllow');
            } else {
                return this.$t('overview.webboxes.disabled');
            }
        }
    },
    mounted() {
        this.exitWizard();
    }
  }
</script>